<template>
  <div class="home-view">
    <HomeMenu></HomeMenu>

    <!-- <transition name="fade" appear :duration="1000"> -->
    <FeaturedEvents
      class="mt-2"
      :show-type="true"
      :key="'home'"
      :title-md="true"
      :section-header-title="$t(`ui.featuredEvents`)"
      :event-type="''"
      :order-limit="5"
      :collection-name="'concert'"
      :header-has-border-top="false"
      :is-carousel="true"
      @events-are-loaded="(val) => rows.firstRowLoaded = val"
    ></FeaturedEvents>
    <!-- </transition> -->

  

    <!-- HOME VIEW WRAPPER -->
    <div class="home-view-wrapper" v-if="rows.firstRowLoaded && user">
      <!-- <h1 class="title is-size-3 mx-1">{{$store.state.appName}}</h1> -->

      <!-- SPONSORED -->
      <FeaturedVenue v-if="false" :event-type="'concert'" class="mt-1 pb-1"></FeaturedVenue>

      <div v-show="$route.name === 'home'">
        <!-- CONCERT -->
        <div v-if="rows.firstRowLoaded">
          <SubtypeCardRail
            key="concertSub"
            :section-header-title="$t(`evType.concert`)"
            :header-has-border-top="true"
            :event-type="'concert'"
            :collection-name="'concert'"
          ></SubtypeCardRail>

          <TypeCard
            key="concert"
            :route-name="$route.name"
            :see-all-path="`/c/${$store.state.user.userCity}/events/concert`"
            :event-type="'concert'"
            :event-limit="6"
            :order-limit="6"
            :section-header-title="`${$options.filters.capitalize($t('ui.upcoming'))} ${$t('evType.concerts')}`"
            @is-loaded="(val) => rows.secondRowLoaded = val"
          ></TypeCard>
        </div>

        <!-- ::theatre:: -->
        <div v-if="rows.secondRowLoaded">
          <SubtypeCardRail
            key="theatreSub"
            :section-header-title="$t(`evType.theatre`)"
            :header-has-border-top="true"
            :event-type="'theatre'"
            :collection-name="'theatre'"
          ></SubtypeCardRail>

          <CardRail
            key="theatre"
            :route-name="$route.name"
            :event-type="'theatre'"
            :see-all-path="`/c/${$store.state.user.userCity}/events/theatre`"
            :section-header-title="`${$options.filters.capitalize($t('ui.upcoming'))} ${$t('evType.theaters')}`"
            :title-sm="true"
            @is-loaded="(val) => rows.thirdRowLoaded = val"
          ></CardRail>
        </div>

        <div v-if="rows.thirdRowLoaded">
          <!-- SPONSORED -->
          <CardRailVenue
            :rail-header="$t('ui.recommendedVenues', { msg: $t('venueTypePlural.theatre')})"
            v-if="user"
            :venue-type="'Theatre'"
            class="pb-1 my-1"
          ></CardRailVenue>

          <!-- **theatre** -->

          <SubtypeCardRail
            key="stageSub"
            :section-header-title="$t(`evType.stage`)"
            :header-has-border-top="false"
            :event-type="'stage'"
            :collection-name="'stage'"
          ></SubtypeCardRail>

          <TypeCard
            key="stage"
            :route-name="$route.name"
            :event-type="'stage'"
            :show-sub-type="true"
            :see-all-path="`/c/${$store.state.user.userCity}/events/stage`"
            :event-limit="6"
            :section-header-title="`${$options.filters.capitalize($t('ui.upcoming'))} ${$options.filters.toLowerCaseTurkish($t('evType.stages'))}`"
          ></TypeCard>
          <!-- **stage ** -->

          <SubtypeCardRail
            key="atelierSub"
            :section-header-title="$t(`evType.atelier`)"
            :header-has-border-top="true"
            :event-type="'atelier'"
            :collection-name="'atelier'"
          ></SubtypeCardRail>

          <!-- <hr class="mt-1 mb-half mx-1" /> -->
          <!-- <SectionHeader :see-all-path="'/events/atelier'" class="mx-1" :title="$t(`ui.featured`)" :title-sm="true"></SectionHeader> -->
          <TypeCard
            key="atelier"
            :route-name="$route.name"
            :event-type="'atelier'"
            :show-sub-type="true"
            :event-limit="6"
            :see-all-path="`/c/${$store.state.user.userCity}/events/atelier`"
            :rail-header="$t(`evType.atelier`)"
            :section-header-title="`${$options.filters.capitalize($t('ui.upcoming'))} ${$t('evType.ateliers')}`"
          ></TypeCard>
          <!-- **atelier** -->

          <!-- ::festival:: -->
          <CardRail
            key="festival"
            :route-name="$route.name"
            :event-type="'festival'"
            :see-all-path="`c/${$store.state.user.userCity}/events/festival`"
            :order-limit="3"
            :section-header-title="$t(`evType.festival`)"
            :title-has-border-top="true"
            :title-lg="true"
          ></CardRail>
          <!-- **festival** -->

          <!-- ::exhibition:: -->
          <CardRail
            key="exhibition"
            :route-name="$route.name"
            :event-type="'exhibition'"
            :show-sub-type="true"
            :order-limit="6"
            :see-all-path="`/c/${$store.state.user.userCity}/events/exhibition`"
            :section-header-title="$t(`evType.exhibition`)"
            :titleLg="true"
          ></CardRail>
          <!-- **exhibition** -->
        </div>
      </div>
    </div>


      <!-- ::LOADING:: -->
    <!-- :active="true" -->
    <div
      v-show="!rows.firstRowLoaded || !rows.secondRowLoaded || !rows.thirdRowLoaded"
      style="min-height: 100px; width: 100%; overflow:hidden; position: relative"
    >
      <b-loading animation :is-full-page="false" :active="!rows.firstRowLoaded || !rows.secondRowLoaded || !rows.thirdRowLoaded" :can-cancel="false"></b-loading>
    </div>
    <!-- **LOADING** -->



    <div
      v-if="$store.state.user.userDoc && rows.thirdRowLoaded"
      class="card mx-1 mt-2 mb-2 has-background-link has-text-white"
      style="border-radius: 8px"
    >
      <InstallPrompt :show-logo="true"></InstallPrompt>
    </div>

    <!-- <div style="height: 64px"></div> -->
    <!-- <hr> -->
    <Footer
      v-if="$store.state.user.authUser"
      :is-centered="true"
      style="margin-bottom: 24px; padding-top: 24px"
    ></Footer>
  </div>
</template>

<script>
import Footer from "@/components/main/Footer";

import { mapGetters } from "vuex";
import cityNamesTR from "@/utilities/cityNames";

export default {
  name: "home",
  components: {
    Footer,
    InstallPrompt: () => import("@/components/shared/InstallPrompt"),
    CardRail: () => import("@/components/rails/CardRail"),
    FeaturedEvents: () => import("@/components/rails/FeaturedEvents"),
    SubtypeCardRail: () => import("@/components/rails/SubtypeCardRail"),
    CardRailVenue: () => import("@/components/rails/CardRailVenue"),
    TypeCard: () => import("@/components/sections/TypeCard"),
    HomeMenu: () => import("@/components/main/HomeMenu")
  },
  metaInfo() {
    let userCity = this.$store.state.user.userCity || "";
    userCity = userCity.concat(` ${this.$t("ui.ofEvents")}`);

    const motto =
      " - " +
      this.$t("evType.concert") +
      ", " +
      this.$t("evType.theatre") +
      ", " +
      this.$t("evType.festival") +
      ", " +
      this.$t("evType.stages") +
      ", " +
      this.$t("evType.atelier") +
      ", " +
      this.$t("ui.buyTicket");

    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: userCity + motto,

      // all titles will be injected into this template
      titleTemplate: "hafta8 | %s",
      meta: [
        {
          name: "description",
          content: "hafta8 ile şehrindeki etkinlikleri keşfet. " + motto
        },
        {
          name: "keywords",
          content: `Şehir, etkinlik, konser, tiyatro, sahne, atölye, festival, bilet al`
        },

        // Google / Schema.org markup:
        { itemprop: "name", content: "hafta8 ← Şehrinkedeki etkinlikler" },
        {
          itemprop: "description",
          content: "hafta8 ile şehrindeki etkinlikleri keşfet. " + motto
        },
        {
          itemprop: "image",
          content: "https://hafta8.com/img/icons/apple-touch-icon-512x512.png"
        },

        // Twitter card
        { name: "twitter:card", content: "summary" },
        {
          name: "twitter:site",
          content: this.$store.state.websiteAddress
        },
        { name: "twitter:title", content: "My Page Title ← My Site" },
        {
          name: "twitter:description",
          content: "I have things here on my site."
        },
        // Your twitter handle, if you have one.
        { name: "twitter:creator", content: "@alligatorio" },
        {
          name: "twitter:image:src",
          content: "https://hafta8.com/img/icons/apple-touch-icon-512x512.png"
        },

        // OpenGraph data (Most widely used)
        { property: "og:title", content: "hafta8 - Events" },
        { property: "og:site_name", content: "hafta8" },
        // The list of types is available here: http://ogp.me/#types
        { property: "og:type", content: "website" },
        // Should the the same as your canonical link, see below.
        {
          property: "og:url",
          content: this.$store.state.websiteAddress
        },
        {
          property: "og:image",
          content: "https://hafta8.com/img/icons/apple-touch-icon-512x512.png"
        },
        // Often the same as your meta description, but not always.
        {
          property: "og:description",
          content: "hafta8 ile şehrindeki etkinlikleri keşfet. " + motto
        }
      ],
      link: [
        {
          rel: "canonical",
          href: "https://hafta8.com"
        }
      ],
      script: [
        {
          type: "application/ld+json"
          // json: {
          //   "@context": "https://schema.org",
          //   "@type": "Event",
          //   url: "https:/hafta8.com" + this.$route.fullPath,
          //   name:
          //     this.event.data.eventName + " " + this.event.data.eventMainType,
          //   startDate: this.$options.filters.toHTMLDateTime(
          //     this.event.data.eventShowtimes[0].startTime
          //   ),
          //   endDate: this.$options.filters.toHTMLDateTime(
          //     this.event.data.eventShowtimes[0].endTime
          //   ),
          //   performer: {
          //     "@type": "Person",
          //     name: this.event.data.eventName
          //   },
          //   // location: {
          //   //   "@type": "Place",
          //   //   name: this.event.data.eventVenueName,
          //   //   address: {
          //   //     "@type": "PostalAddress",
          //   //     streetAddress: "Ilkadim sokak. Çankaya no 21",
          //   //     addressLocality: "Ankara",
          //   //     postalCode: "06680",
          //   //     addressCountry: "TR"
          //   //   }
          //   // },
          //   description: this.event.details.eventSummary,
          //   image: this.event.data.eventImagePaths.posterURLs[0],
          //   offers: {
          //     "@type": "Offer",
          //     availability: "https://schema.org/InStock",
          //     price: this.calcMainTicketPrice(this.event.data.eventTicketInfo), // TODO remove tl from result
          //     priceCurrency: "TRY",
          //     url: "https:/hafta8.com" + this.$route.fullPath
          //   }
          // }
        }
      ]
    };
  },
  data() {
    return {
      cityNamesTR,
      cityNames: ["Ankara"],
      isHomePageFetched: true,
      isShowCities: false,
      sponsoredTheatres: [],
      sponsoredConcerts: [],
      lastScrollPosition: 0,
      rows: {
        firstRowLoaded: false,
        secondRowLoaded: false,
        thirdRowLoaded: false
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "user/userDoc",
      userCity: "user/userCity"
    })
  },
  async created() {
    // const res = await this.$store.dispatch("appData/fetchHomePageEvents");
    // this.isHomePageFetched = res ? true : false;
  },
  methods: {
    citySelected(event) {
      this.$store.dispatch("user/setUserCity", event.target.value);
      this.isShowCities = false;
      event.srcElement.blur();
      window.scrollTo(0, 0);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.$analytics.logEvent("hit_logo");
    }
  }
};
</script>
